function SectionCard({ title, subtitle, children }) {
  return (
    <section className="section-card">
      <header>
        <h3>{title}</h3>
        {subtitle ? <p>{subtitle}</p> : null}
      </header>
      <div>{children}</div>
    </section>
  );
}

export default SectionCard;